import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeadingModule from "../components/modules/heading-module"
import MarkdownModule from "../components/modules/html-markdown"
import { useWeddingsData } from "../hooks/use-weddings-data"
class ContactPage extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title;

	const ContentContainer = () => {
		const { heading, weddingsContent } = useWeddingsData();
		return (
			<div>
				<HeadingModule
					headingText={ heading.headingText }
					subHeadingText={ heading.subHeadingText }
					subHeadingMaxWidth={ heading.subHeadingMaxWidth}
					headingImageAbove={ heading.headingImageAbove.childImageSharp.fluid }
				/>
				<section className="darker py-5">
					<div className="container">
						<div className="d-none d-small-inline-block col-1-8"></div>
						<div className="col-6-8">
							<MarkdownModule
								markdown={ weddingsContent }
								classes="weddings-content"
							/>
						</div>
					</div>
				</section>
			</div>
		)
	}

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Weddings - Niwot Inn &amp; Spa" />
		<div className="weddings-page">
			<ContentContainer />
		</div>
      </Layout>
    )
  }
}

export default ContactPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
